<template>
    <div class="right_box_main">
        <!-- 面包屑导航 -->
        <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/griddingindex' }"
                    >网格工作</el-breadcrumb-item
                >
                <el-breadcrumb-item>社区议事协商</el-breadcrumb-item>
                <el-breadcrumb-item>议事协商</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div :body-style="{ padding: '16px' }" class="card-r-0">
                    <div class="card-0">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B1.png"
                                alt
                            />
                            议题状态
                        </div>

                        <div class="onebuttom">
                            <div class="child-item">
                                <div>{{ showDatas.statusBefore }}</div>
                                <div>未开始</div>
                            </div>
                            <div class="child-item">
                                <div>{{ showDatas.statusIn }}</div>
                                <div>商议中</div>
                            </div>
                            <div class="child-item">
                                <div>{{ showDatas.statusOut }}</div>
                                <div>已结束</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-2">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B2.png"
                                alt
                            />
                            协商处理过程
                        </div>
                        <div class="onebuttom">
                            <div class="child-item">
                                <div>{{ showDatas.processWait }}</div>
                                <div>待审批</div>
                            </div>
                            <div class="child-item">
                                <div>{{ showDatas.processDelay }}</div>
                                <div>会议延迟</div>
                            </div>
                            <div class="child-item">
                                <div>{{ showDatas.processEnd }}</div>
                                <div>录入协商结果</div>
                            </div>
                            <div class="child-item">
                                <div>{{ showDatas.processDiss }}</div>
                                <div>待点评</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-3">
                        <div class="topbarnav" style="float: left">
                            <img
                                src="../../../assets/images/icons/B3.png"
                                alt
                            />
                            协商处理满意度
                        </div>
                        <div class="topbarnav" style="float: left">
                            <img
                                src="../../../assets/images/icons/B2.png"
                                alt
                            />政策法规列表
                        </div>
                        <div style="clear: both"></div>
                        <div class="onebuttom">
                            <div
                                class
                                id="chart_1_1"
                                style="border-right: 1px solid #ccc"
                            ></div>
                            <div class id="chart_1_2">
                                <div class="listtit">标题</div>
                                <div
                                    v-for="item in zcfgList"
                                    :key="item.id"
                                    class="listcli"
                                    @click="moveout"
                                >
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :body-style="{ padding: '16px' }" class="card-r">
                    <el-card class="card-0">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B4.png"
                                alt
                            />
                            <div>按议题类型查看</div>
                        </div>
                        <div class="onebuttom">
                            <div id="chart_2_1"></div>
                        </div>
                    </el-card>
                    <el-card class="card-2 flexDirectionColumn">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B5.png"
                                alt
                            />
                            <div>网格地图</div>
                        </div>
                        <div class="onebuttom flexDirectionRow">
                            <div class="onebuttom-left">
                                <h5>绩溪智慧社区</h5>
                                <div>
                                    <span>待审批</span>
                                    <span>{{ showDatas.processWait }}</span>
                                </div>
                                <div>
                                    <span>商议中</span>
                                    <span>{{ showDatas.statusIn }}</span>
                                </div>
                                <div>
                                    <span>上传签到表</span>
                                    <span>{{ showDatas.statusIn }}</span>
                                </div>
                                <div>
                                    <span>录入协商结果</span>
                                    <span>{{ showDatas.processEnd }}</span>
                                </div>
                                <div>
                                    <span>待点评</span>
                                    <span>{{ showDatas.processDiss }}</span>
                                </div>
                            </div>
                            <div class="onebuttom-right">
                                <img
                                    src="../../../assets/images/Gridding/DT2.png"
                                    alt
                                />
                            </div>
                        </div>
                    </el-card>
                    <el-card class="card-3">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B6.png"
                                alt
                            />
                            <div>专家风采</div>
                        </div>
                        <div class="onebuttom">
                            <el-table :data="professorlist">
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="排名"
                                ></el-table-column>
                                <el-table-column
                                    prop="photo"
                                    align="right"
                                    width="50"
                                >
                                    <template slot-scope="scope">
                                        <img
                                            :src="scope.row.photo"
                                            width="24"
                                            height="24"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="专家姓名"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="frequency"
                                    align="center"
                                    label="参会次数"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </div>
                <!-- 协商案例推荐 -->
                <div class="card-tuijian">
                    <el-card :body-style="{ padding: '16px' }">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B7.png"
                                alt
                            />
                            协商案例推荐
                        </div>
                        <div
                            style="width: 100%; height: 100%; padding-top: 30px"
                        >
                            <!-- <el-carousel trigger="click" height="260px">
                <el-carousel-item v-for="(item, index) in lunboimgurlcenter" :key="index">
                  <img :src="item" alt />
                </el-carousel-item>
              </el-carousel>-->
                            <el-carousel
                                :interval="4000"
                                type="card"
                                height="200px"
                            >
                                <el-carousel-item
                                    v-for="(item, index) in lunboimgurlcenter"
                                    :key="index"
                                >
                                    <img :src="item" alt />
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </el-card>
                </div>
                <!-- 人员信息库 -->
                <div class="card-4">
                    <el-card
                        :body-style="{ padding: '16px' }"
                        class="card-4-left"
                    >
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B8.png"
                                alt
                            />
                            人员信息库
                        </div>
                        <div class="fisthang">
                            <el-form
                                :inline="true"
                                :model="searchlist"
                                class="demo-form-inline"
                                size="mini"
                            >
                                <el-form-item label="姓名:">
                                    <el-input
                                        v-model="searchlist.name"
                                        placeholder="请输入姓名"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="专业:">
                                    <el-select
                                        clearable
                                        v-model="searchlist.major"
                                        placeholder="--请选择--"
                                        style="width: 150px"
                                    >
                                        <el-option
                                            v-for="item in searchTypes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item clearable label="参加协商次数:">
                                    <el-select
                                        v-model="searchlist.num"
                                        placeholder="--请选择--"
                                        style="width: 150px"
                                    >
                                        <el-option
                                            v-for="item in searchNum"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        @click="searchlistdata"
                                        >查询</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                            class="shoutwosearch"
                            v-if="doshowsearchlistdata"
                        ></div>
                        <!-- 表格盒子 -->
                        <div class="table_card">
                            <el-table
                                :data="tableData"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                align="center"
                                current-row-key
                                highlight-current-row
                            >
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="排名"
                                    width="50"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="name"
                                    label="姓名"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="sex"
                                    label="性别"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="phone"
                                    label="手机号"
                                    width="200px"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="numberId"
                                    label="身份证号"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="major"
                                    label="专业"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="frequency"
                                    label="参加协商次数"
                                ></el-table-column>
                            </el-table>
                            <el-pagination
                                :page-size="pageConfig.pageSize"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleCurrentChange"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </div>
                    </el-card>
                    <!-- 人员统计信息 -->
                    <el-card class="card-4-right">
                        <div class="topbarnav">
                            <img
                                src="../../../assets/images/icons/B9.png"
                                alt
                            />
                            人员统计
                        </div>
                        <div class="onebuttom">
                            <div class="onebuttom-up" id="chart_3_1"></div>
                            <div
                                class="onebuttom-down-left"
                                id="chart_3_2"
                            ></div>
                            <div
                                class="onebuttom-down-right"
                                id="chart_3_3"
                            ></div>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { log } from "util"
import { exists } from "fs"
import echarts_msg from "../../../utils/echarts.js"
import request from "../../../utils/request.js"
import { getConsulTYpePersion } from "@/api/http.js"
// import {getSjzdList} from "@/api/api"
let token = JSON.parse(window.localStorage.getItem("user"))
export default {
    data() {
        return {
            zcfgList: [],
            showDatas: {
                statusBefore: "0",
                statusIn: "0",
                statusOut: "0",
                processWait: "0",
                processDelay: "0",
                processEnd: "0",
                processDiss: "0",
            },
            gridingData: {},
            searchlist: {},
            professorlist: [],
            lunboimgurlcenter: [require("../../../assets/images/xidada.png")],
            // 查询
            doshowsearchlistdata: false,
            searchTypes: [],
            searchNum: [],
            //表格数据
            tableData: [],
            // 分页配置
            pageConfig: {
                pageSize: 5,
                total: 0,
                pageNo: 1,
            },
        }
    },
    methods: {
        //点击标题
        moveout() {
            this.$router.push({ path: "/communityIssueFg" })
        },
        //获取政策法规标题列表
        getZcfgList() {
            getSjzdList({
                pageSize: 999,
                total: 0,
                pageNo: 1,
            }).then((res) => {
                this.zcfgList = res.content.list
            })
        },
        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            // fd.append("findConsultPerson", params);

            var res = await getConsulTYpePersion({
                ...this.pageConfig,
                ...this.searchlist,
            })
            if (res.code == 200) {
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常：",
                    type: "error",
                })
            }
        },
        //获取条件查询的一级分类
        async getPTypes() {
            let fd = new FormData()
            fd.append("token", token)
            let params = JSON.stringify({ parentId: 0 })
            fd.append("consultType", params)
            var res = await request({
                url: "/admin/consulType/info/findConsultType",
                method: "POST",
                data: fd,
            })
            var temp = {}
            if (res.content.length > 0) {
                res.content.forEach((item) => {
                    temp = { value: item.consultName, label: item.consultName }
                    this.searchTypes.push(temp)
                })
            }
            //默认写死
            this.searchNum = [
                { value: "21", label: "20次以上" },
                { value: "20", label: "10~20次" },
                { value: "10", label: "5~10次" },
                { value: "5", label: "1~5次" },
                { value: "0", label: "1次以下" },
            ]
        },
        // 图表加载函数
        async drawChart() {
            var res = await request({
                url: "/admin/consul/info/consultHomeStatistics",
                method: "POST",
                data: {},
            })
            console.log(res)
            var option_1_1_data = []
            var option_1_2_data = []
            var option_2_1_text = []
            var option_2_1_data = []
            var option_3_1_text = []
            var option_3_1_data = []
            var option_3_2_text = []
            var option_3_2_data = []
            var option_3_3_text = []
            var option_3_3_data = []

            if (res.code == 200) {
                this.showDatas = {
                    statusBefore: res.content.consultStatus[0].wks || "",
                    statusIn: res.content.consultStatus[0].syz,
                    statusOut: res.content.consultStatus[0].yjs,
                    processWait: res.content.consultProcess[0].dsp,
                    processDelay: res.content.consultProcess[0].hyyc,
                    processEnd: res.content.consultProcess[0].lrxsjg,
                    processDiss: res.content.consultProcess[0].ddp,
                }
                //轮播图
                if (res.content.casesPhoto) {
                    var imgUrl = ""
                    res.content.casesPhoto.forEach((item, index) => {
                        if (item.casesPhoto) {
                            imgUrl = item.casesPhoto
                        } else {
                            imgUrl = require("../../../assets/images/xidada.png")
                        }
                        this.lunboimgurlcenter.push(imgUrl)
                    })
                }
                //满意度统计图
                if (res.content.satisfied) {
                    option_1_1_data = [
                        {
                            value: res.content.satisfied[0].sj_sfmy,
                            name: "双方满意",
                        },
                        {
                            value: res.content.satisfied[0].sj_dfmy,
                            name: "多方不满意",
                        },
                        {
                            value: res.content.satisfied[0].sj_yfbmy,
                            name: "一方满意",
                        },
                    ]
                    option_1_2_data = [
                        {
                            value: res.content.satisfied[0].xs_sfmy,
                            name: "双方满意",
                        },
                        {
                            value: res.content.satisfied[0].xs_dfbmy,
                            name: "多方不满意",
                        },
                        {
                            value: res.content.satisfied[0].xs_yfmy,
                            name: "一方满意",
                        },
                        {
                            value: res.content.satisfied[0].xs_xswg,
                            name: "协商未果",
                        },
                    ]
                }
                if (res.content.consultType) {
                    res.content.consultType.forEach((item, index) => {
                        option_2_1_text.push(item.typeName)
                        option_2_1_data.push(item.number)
                    })
                }
                if (res.content.major) {
                    res.content.major.forEach((item, index) => {
                        if (item.majorName) {
                            option_3_1_text.push(item.majorName)
                            option_3_1_data.push(item.number)
                        }
                    })
                }
                if (res.content.personType) {
                    res.content.personType.forEach((item, index) => {
                        if (item.typeName) {
                            option_3_2_text.push(item.typeName)
                            option_3_2_data.push(item.number)
                        }
                    })
                }
                if (res.content.sex) {
                    res.content.sex.forEach((item, index) => {
                        if (item.sexName) {
                            option_3_3_text.push(item.sexName)
                            option_3_3_data.push({
                                value: item.number,
                                name: item.sexName,
                            })
                        }
                    })
                }
            }
            // 按事件处理结果满意度 饼状图
            let myChart_l_1 = this.$echarts.init(
                document.getElementById("chart_1_1")
            )
            var option_1_1 = echarts_msg.option_pie
            option_1_1.title.text = "按事件处理结果满意度"
            //option_1_1.legend.data = ['双方满意', '多方不满意', '一方满意']
            option_1_1.series[0].name = "满意度"
            option_1_1.series[0].data = option_1_1_data
            myChart_l_1.setOption(option_1_1)

            // 按协商结果满意度 饼状图
            // let myChart_1_2 = this.$echarts.init(
            //   document.getElementById("chart_1_2")
            // );
            // var option_1_2 = echarts_msg.option_pie;
            // option_1_2.title.text = "按协商结果满意度";
            // //option_1_2.legend.data = ['双方满意', '多方不满意', '一方满意','协商未果']
            // option_1_2.series[0].name = "满意度";
            // option_1_2.series[0].data = option_1_2_data;
            // myChart_1_2.setOption(option_1_2);

            //按议题类型查看 柱状图
            // let myChart_2_1 = this.$echarts.init(
            //   document.getElementById("chart_2_1")
            // );
            // var option_2_1 = echarts_msg.option_bar;
            // option_2_1.title.text = "";
            // option_2_1.xAxis.type = "value";
            // option_2_1.yAxis.type = "category";
            // option_2_1.yAxis.data = option_2_1_text;
            // option_2_1.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
            //   0,
            //   0,
            //   1,
            //   0,
            //   [
            //     { offset: 0, color: "#ff8383" },
            //     { offset: 1, color: "#ffe5e6 " }
            //   ]
            // );
            // option_2_1.series[0].data = option_2_1_data;
            // myChart_2_1.setOption(option_2_1);

            //按专业类别查看 柱状图
            let myChart_3_1 = this.$echarts.init(
                document.getElementById("chart_3_1")
            )
            var option_3_1 = echarts_msg.option_bar
            option_3_1.title.text = "按专业类别查看"
            option_3_1.xAxis.type = "value"
            option_3_1.yAxis.type = "category"
            option_3_1.yAxis.data = option_3_1_text
            option_3_1.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0,
                [
                    { offset: 0, color: "#ff8383" },
                    { offset: 1, color: "#ffe5e6 " },
                ]
            )
            option_3_1.series[0].data = option_3_1_data
            myChart_3_1.setOption(option_3_1)
            //按人员类别查看
            let myChart_3_2 = this.$echarts.init(
                document.getElementById("chart_3_2")
            )
            var option_3_2 = echarts_msg.option_bar
            option_3_2.title.text = "按人员类别查看"
            option_3_2.xAxis.type = "category"
            option_3_2.xAxis.data = option_3_2_text
            option_3_2.yAxis.type = "value"
            option_3_2.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
                1,
                0,
                1,
                1,
                [
                    { offset: 0, color: "#45b6e75c" },
                    { offset: 1, color: "#45b6e7 " },
                ]
            )
            option_3_2.series[0].data = option_3_2_data
            myChart_3_2.setOption(option_3_2)
            // 按人员性别查看 饼状图
            let myChart_3_3 = this.$echarts.init(
                document.getElementById("chart_3_3")
            )
            var option_3_3 = echarts_msg.option_pie
            option_3_3.title.text = "按人员性别查看"
            option_3_3.legend.data = option_3_3_text
            option_3_3.series[0].name = "男女占比"
            option_3_3.series[0].data = option_3_3_data
            myChart_3_3.setOption(option_3_3)

            let sizeFun = function () {
                myChart_l_1.resize()
                myChart_1_2.resize()
                myChart_2_1.resize()
                myChart_3_1.resize()
                myChart_3_2.resize()
                myChart_3_3.resize()
            }
            window.addEventListener("resize", sizeFun)
        },
        //获取专家风采
        async getProfessorList() {
            var res = await request({
                url: "/admin/consulType/info/expertStatistics",
                method: "POST",
                data: {},
            })
            if (res.code == 200) {
                if (res.content.personType) {
                    var photo = ""
                    res.content.personType.forEach((item, index) => {
                        if (item.photo) {
                            photo = item.photo
                        } else {
                            photo = require("../../../assets/images/Gridding/P1.png")
                        }
                        this.professorlist.push({
                            photo: photo,
                            name: item.name,
                            frequency: item.frequency,
                        })
                    })
                }
            }
        },
    },
    mounted() {
        // 初始化图表加载
        this.drawChart()
        // //网格数据
        // this.gridingData = {
        //   title: '秋浦街道智慧社区',
        //   list: [
        //     {text: '待审批', value: '3'},
        //     {text: '商议中', value: '8'},
        //     {text: '上传签到表', value: '57'},
        //     {text: '录入协商结果', value: '100'},
        //     {text: '待点评', value: '8'}
        //   ]
        // }

        this.getProfessorList()
        this.getPTypes()
        this.getPageDatas()
        this.getZcfgList()
    },
}
</script>

<style lang="less" scoped>
.listtit {
    height: 32px !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f4f4f4;
}
.listcli {
    height: 25px !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
}
//  包裹两个卡片的盒子
.card-box {
    display: flex;
    /* 议题状态 行 */
    .card-r-0 {
        // overflow: hidden;
        flex: 1;
        // margin-left:10px;
        padding: 0 10px;
        height: 150px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .topbarnav {
            display: flex;
            align-items: center;
            font-size: 14px;
            text-indent: 5px;
            width: 50%;
            img {
                width: 22px;
                padding-right: 10px;
            }
        }
        .card-0 {
            width: calc(30% - 10px);
            height: 150px;
            .onebuttom {
                margin-top: 8px;
                height: 80px;
                padding: 20px 0;
                border: 1px solid #ccc;
                background-color: #fff;
                .child-item {
                    float: left;
                    width: 32%;
                    /*border-left: 1px solid #ccc;*/
                    line-height: 40px;
                    div {
                        width: 100%;
                        text-align: center;
                    }
                    div:first-child {
                        font-size: 24px;
                        color: red;
                    }
                    div:last-child {
                        font-size: 14px;
                    }
                }
                div:first-child {
                    border-left: 0px;
                }
            }
        }
        .card-2 {
            width: 41.5%;
            height: 150px;
            .onebuttom {
                margin-top: 8px;
                height: 120px;
                .child-item {
                    float: left;
                    width: 22%;
                    margin-left: 3.3%;
                    border: 1px solid #ccc;
                    background-color: #fff;
                    padding: 20px 0;
                    line-height: 40px;
                    div {
                        width: 100%;
                        text-align: center;
                    }
                    div:first-child {
                        font-size: 24px;
                        color: red;
                    }
                    div:last-child {
                        font-size: 14px;
                    }
                }
                div:first-child {
                    margin-left: 0px;
                }
            }
        }
        .card-3 {
            width: 28%;
            height: 150px;
            .onebuttom {
                margin-top: 8px;
                height: 110px;
                padding: 5px 0;
                border: 1px solid #ccc;
                background-color: #fff;
                div {
                    float: left;
                    width: 49%;
                    height: 110px;
                    text-align: center;
                    /*border-left: 1px solid #ccc;*/
                }
                div:first-child {
                    border-left: 0px;
                }
            }
        }
    }
    /* 网格地图 行 */
    .card-r {
        // overflow: hidden;
        flex: 1;
        margin-top: 12px;
        height: 320px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .card-0 {
            width: calc(30% - 10px);
            height: 320px;
            .onebuttom {
                height: 258px;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .card-2 {
            width: 41.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                .onebuttom-left {
                    float: left;
                    width: 30%;
                    background-color: #ef84842e;
                    line-height: 30px;
                    margin-top: 40px;
                    padding-bottom: 10px;
                    h5 {
                        text-align: center;
                        border-bottom: 1px solid #ef848452;
                        line-height: 40px;
                    }
                    div {
                        width: 100%;
                        font-size: 12px;
                        span:first-child {
                            float: left;
                            width: 70%;
                            text-align: left;
                            text-indent: 8px;
                        }
                        span:last-child {
                            float: left;
                            width: 30%;
                            text-align: center;
                        }
                    }
                }
                .onebuttom-right {
                    float: right;
                    width: 70%;
                    text-align: center;
                    vertical-align: middle;
                    img {
                        width: 300px;
                        height: 270px;
                    }
                }
            }
        }
        .card-3 {
            width: 28%;
            height: 320px;
            .onebuttom {
                width: 100%;
                height: 320px;
            }
        }
        .topbarnav {
            display: flex;
            align-items: center;
            width: 50%;
            float: left;
            img {
                width: 22px;
                padding-right: 10px;
            }
            div {
                box-sizing: border-box;
                font-size: 14px;
            }
        }
    }
}
/* 协商案例推荐 */
.card-tuijian {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 0 10px;
    box-sizing: border-box;
    .topbarnav {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-indent: 5px;
        img {
            width: 22px;
            padding-right: 10px;
        }
    }
    .el-carousel__item img {
        line-height: 200px;
        margin: 0;
    }
}

/* 人员信息库 */
.card-4 {
    width: 100%;
    // height: 320px;
    box-sizing: border-box;
    margin-top: 12px;
    .topbarnav {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-indent: 5px;
        img {
            width: 22px;
            padding-right: 10px;
        }
    }
    .card-4-left {
        float: left;
        width: 70%;
        .fisthang {
            margin-top: 8px;
            border-top: 1px solid #ccc;
            padding-top: 12px;
        }
    }
    .card-4-right {
        float: right;
        /*width: 28%;*/
        width: calc(30% - 10px);
        .onebuttom {
            margin-top: 8px;
            .onebuttom-up {
                float: left;
                width: 100%;
                height: 200px;
                border-top: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
            }
            .onebuttom-down-left {
                float: left;
                width: 49%;
                margin: 10px 0;
                height: 180px;
                border-right: 1px solid #ccc;
                padding-right: 1%;
            }
            .onebuttom-down-right {
                float: right;
                width: 49%;
                margin: 10px 0;
                height: 180px;
            }
        }
    }
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 16px 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0 6px;
        }
        .tabBtn:nth-child(1) {
            color: #199b5d;
            font-size: 22px;
        }
        .tabBtn:nth-child(2) {
            color: #ff04ed;
            // font-size: 25px;
        }
        .tabBtn:nth-child(3) {
            color: #dd3020;
            // font-size: 25px;
        }
        .tabBtn:nth-child(5) {
            color: #e400ff;
            font-size: 22px;
        }
        .tabBtn:nth-child(4) {
            color: #2e99cf;
            // font-size: 25px;
        }
        .active_Btn {
            color: #ff04ed !important;
            // font-size: 25px;
        }
    }
}
.flexDirectionColumn /deep/.el-card__body {
    display: flex;
    flex-direction: column;
}
.flexDirectionRow {
    display: flex;
    flex-direction: row;
}
</style>
